import React, { useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { toText, byLabelAsc } from "../../utils/textAndSort";


function CheckboxListBox({ title, items, selected, onChange, height = 360, footerButtons }) {
const allChecked = useMemo(() => items.length > 0 && items.every((it) => selected.has(it.id)), [items, selected]);
const someChecked = useMemo(() => !allChecked && items.some((it) => selected.has(it.id)), [items, selected, allChecked]);


const toggle = useCallback((id) => {
const next = new Set(selected);
next.has(id) ? next.delete(id) : next.add(id);
onChange(next);
}, [selected, onChange]);


const toggleAll = useCallback(() => {
onChange(allChecked ? new Set() : new Set(items.map((i) => i.id)));
}, [allChecked, items, onChange]);


const ordered = useMemo(() => [...items].sort(byLabelAsc), [items]);


return (
<div className="listbox">
<div className="listbox-header">
<button type="button" className="listbox-header-toggle" onClick={toggleAll} aria-pressed={allChecked}>
<span className={`checkbox ${allChecked ? "checked" : someChecked ? "indeterminate" : ""}`} />
<span className="listbox-title">{title}</span>
</button>
</div>


<div className="listbox-body" style={{ maxHeight: height }}>
{ordered.map((it) => (
<label key={it.id} className="listbox-item">
<input type="checkbox" checked={selected.has(it.id)} onChange={() => toggle(it.id)} />
<span className="listbox-item-label">
{toText(it.label)}
{typeof it.count === "number" ? <span className="muted"> ({it.count})</span> : null}
</span>
</label>
))}
{ordered.length === 0 && <div className="listbox-empty">No options</div>}
</div>


{footerButtons ? <div className="listbox-footer">{footerButtons}</div> : null}
</div>
);
}


CheckboxListBox.propTypes = {
title: PropTypes.string.isRequired,
items: PropTypes.arrayOf(
PropTypes.shape({ id: PropTypes.string.isRequired, label: PropTypes.string.isRequired, count: PropTypes.number })
).isRequired,
selected: PropTypes.instanceOf(Set).isRequired,
onChange: PropTypes.func.isRequired,
height: PropTypes.number,
footerButtons: PropTypes.node,
};


export default CheckboxListBox;